import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import SiteHeader from './components/SiteHeader';
import SiteFooter from './components/SiteFooter';
import ScrollManager from './components/ScrollManager';
import NotFoundPage from './pages/NotFoundPage';
import HomePage from './pages/HomePage';
import ProductPage from './pages/ProductPage';

const App = () => (
  <BrowserRouter>
    <a className="skip-link" href="#main-content">Skip to main content</a>
    <ScrollManager />
    <SiteHeader />
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/products/:slug" element={<ProductPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
    <SiteFooter />
  </BrowserRouter>
);

export default App;
